<template>
  <header class="header">
    <div class="nav-box" :class="{ 'fixed-head': isFixedTop }" id="index">
      <div class="nav-left">
        <div class="logo" @click="selectNav('0')">
          <img src="../image/logo/sys-logo.png"/>
        </div>
        <ul class="nav-ul">
          <li
            v-for="item in nevigatelist"
            :_t_nav="item.nav"
            :key="item.id"
            :class="[{ 'selected-li': isNavSelected === item.id }, 'nav-li']"
            @click="selectNav(item.id, item.path)"
          >
            <span :class="{ 'title-active': item.active }">{{
              item.label
            }}</span>
            <ul class="child-ul">
              <li v-for="children in item.child" :key="children.id">
                <span @click="goPage(children.path)">{{ children.label }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="nav-right">
        <div class="nav-phone">
          <img src="../image/header/phone.svg" class="phone" />
          <div><span>咨询致电：</span><span>400-010-0986</span></div>
        </div>
        <div class="nav-login">
          <el-button
            round
            class="management-center"
            type="primary"
            @click="goLogin"
            >登录/注册</el-button
          >
          <el-button round class="partner-settlement" @click="goTrial"
            >我要试用</el-button
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import $ from "jquery";
import {
  login,
  queryUserFlag,
  creatImgCode,
  validateImgCode,
  queryCompanyUserMenus,
} from "@/common/api.js";
export default {
  data() {
    return {
      inputOne: "",
      activeName: "",
      tabOneshow: false,
      isNavSelected: "0",
      isToTop: false,
      isFixedTop: false,
      isshowLogin: false,
      activeName: "first",
      level1Menu: [],
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      verificationImg: "",
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, validator: this.validateCode, trigger: "blur" },
        ],
      },
      userFlag: "",
      nevigatelist: [
        {
          id: "0",
          path: "/",
          label: "首页",
          active: true,
        },
        {
          id: "1",
          nav: "digital-products",
          label: "数字产品服务",
          active: false,
          child: [
            {
              id: "1-1",
              path: "/index/digitalTraceability",
              label: "防伪追溯服务",
            },
            {
              id: "1-8",
              path: "/index/signMaking",
              label: "标识制作服务",
            },
            {
              id: "1-2",
              path: "/index/fleeingGoods",
              label: "防窜货服务",
            },
            {
              id: "1-3",
              path: "/index/digitalMarketing",
              label: "数字营销",
            },
            {
              id: "1-4",
              path: "/index/codingService",
              label: "赋码服务",
            },
            {
              id: "1-5",
              path: "/index/dataApply",
              label: "大数据分析服务",
            },
            {
              id: "1-6",
              path: "/index/secondNode",
              label: "二级节点解析服务",
            },
            {
              id: "1-7",
              path: "/index/more",
              label: "更多服务",
            },
          ],
        },
        {
          id: "2",
          nav: "industry-solutions",
          label: "行业解决方案",
          active: false,
          child: [
            {
              id: "2-1",
              path: "/index/salt",
              label: "食盐行业",
            },
            {
              id: "2-2",
              path: "/index/huafei",
              label: "化肥行业",
            },
            {
              id: "2-3",
              path: "/index/yurong",
              label: "羽绒行业",
            },
            {
              id: "2-4",
              path: "/index/kuaixiaopin",
              label: "快消品行业",
            },
            {
              id: "2-5",
              path: "/index/others",
              label: "更多行业",
            },
          ],
        },
        {
          id: "3",
          nav: "bigdata-analytics",
          label: "服务对象",
          active: false,
          child: [
            {
              id: "3-1",
              path: "/index/business",
              label: "大型、中小微企业",
            },
            {
              id: "3-2",
              path: "/index/government",
              label: "政府、协会等机构",
            },
            {
              id: "3-3",
              path: "/index/consumer",
              label: "亿万消费者",
            },
          ],
        },
        {
          id: "4",
          path: "/index/cooperation",
          nav: "cooperation",
          label: "合作案例",
          active: true,
        },
        {
          id: "5",
          path: "/index/news",
          nav: "news",
          label: "新闻资讯",
          active: true,
        },
        {
          id: "6",
          path: "/index/aboutUs",
          nav: "about-us",
          label: "关于我们",
          active: true,
        },
      ],
    };
  },
  watch: {
    $route() {
      this.updateRoute();
    },
  },
  mounted() {
    this.updateRoute();
    // 下拉导航
    $(document).ready(function () {
      var qcloud = {};
      $("[_t_nav]").hover(
        function () {
          var _nav = $(this).attr("_t_nav");
          $(this).find("ul").css("display", "block");
          $(this).siblings().find("ul").css("display", "none");
          $("[_t_nav]").each(function () {
            $(this)[
              _nav == $(this).attr("_t_nav") ? "addClass" : "removeClass"
            ]("nav-up-selected");
          });
          // clearTimeout(qcloud[_nav + "_timer"]);
          // qcloud[_nav + "_timer"] = setTimeout(function () {
          //   $("[_t_nav]").each(function () {
          //     $(this)[
          //       _nav == $(this).attr("_t_nav") ? "addClass" : "removeClass"
          //     ]("nav-up-selected");
          //   });
          //   $("#" + _nav)
          //     .stop(true, true)
          //     .slideDown(200);
          // }, 150);
        },
        function () {
          $(this).find("ul").css("display", "none");
          $("[_t_nav]").removeClass("nav-up-selected");
          // var _nav = $(this).attr("_t_nav");
          // clearTimeout(qcloud[_nav + "_timer"]);
          // qcloud[_nav + "_timer"] = setTimeout(function () {
          //   $("[_t_nav]").removeClass("nav-up-selected");
          //   $("#" + _nav)
          //     .stop(true, true)
          //     .slideUp(200);
          // }, 150);
        }
      );
    });

    $(window).on("scroll", () => {
      // console.log(window.scrollY);
      if (window.scrollY > 100) {
        this.isFixedTop = true;
      } else {
        this.isFixedTop = false;
      }
      if (window.scrollY > 300) {
        this.isToTop = true;
      } else {
        this.isToTop = false;
      }
    });
    this.getqueryUserFlag();
  },
  methods: {
    close() {
      this.isshowLogin = false;
    },
    goPage(path) {
      this.$router.push({
        path: path,
      });
      $(".child-ul").css("display", "none");
    },
    goLogin() {
      // this.isshowLogin = true;
      this.$router.push({
        path: "/login",
      });
    },
    tabHandleClick(tab) {
      if (tab.index === "0") {
        this.tabOneshow = !this.tabOneshow;
      }
    },
    // 获取导航菜单
    queryCompanyUserMenus() {
      queryCompanyUserMenus().then((res) => {
        console.log("res :>> ", res);
        if (res.errorCode == 200) {
          if (res.companyNavigationPer) {
            window.sessionStorage.setItem(
              "routerList",
              JSON.stringify(res.companyNavigationPer.children)
            );
            this.level1Menu = res.systemNavigations;
            this.$store.dispatch("getlevel1Menu", this.level1Menu);
          }
          this.$nextTick(function () {
            this.$router.push({
              path: "/user/home",
            });
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    goUserHome(formName, userName, password) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = {
            userName,
            password,
          };
          login(params).then((res) => {
            if (res.errorCode == 200) {
              var token = res.token;
              var userType = res.userType;
              var userName = res.companyUserVO.userName;
              var companyType = res.companyUserVO.companyInfo.companyType;
              var companyId = res.companyUserVO.companyId;
              var companyName = res.companyUserVO.companyInfo.companyName;
              var userId = res.companyUserVO.userId;
              if (res.companyUserVO.companyInfo.authFlag == 2) {
                this.queryCompanyUserMenus();
              } else {
                this.$router.push({
                  path: "/user/home",
                });
              }
              this.$store.dispatch("getCompanyType", companyType);
              window.sessionStorage.setItem("companyId", companyId);
              window.sessionStorage.setItem("token", token);
              window.sessionStorage.setItem("userType", userType);
              window.sessionStorage.setItem("userName", userName);
              window.sessionStorage.setItem("userId", userId);
              window.sessionStorage.setItem("companyName", companyName);
              //  this.$router.push({
              //   path: "/user/home",
              // });
            } else {
              this.$message.error("账号或者密码错误");
            }
          });
        } else {
          return false;
        }
      });
    },
    checkImageCode() {
      this.getqueryUserFlag();
    },
    getqueryUserFlag() {
      queryUserFlag().then((res) => {
        if (res.errorCode == 200) {
          this.userFlag = res.userFlag;
          this.getImageCode(this.userFlag);
        }
      });
    },
    getImageCode(userFlag) {
      this.$axios({
        method: "post",
        url: "/permissions/regist/createValidateImg",
        data: {
          userFlag: userFlag,
        },
        responseType: "arraybuffer",
        ContentType: "application/json;charset=UTF-8",
      }).then((response) => {
        if (response.data) {
          this.verificationImg =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        }
      });
    },
    validateCode(rule, value, callback) {
      var params = {
        userFlag: this.userFlag,
        imageCheckCode: value,
      };
      if (value == "") {
        callback(new Error("请输入图文验证码"));
      }
      if (value) {
        validateImgCode(params).then((res) => {
          if (res.errorCode != 200) {
            callback(new Error(res.msg));
          }
          callback();
        });
      }
    },
    goregisterded(type) {
      this.$store.dispatch("getType", type);
      this.$router.push({
        path: "/user/registered",
      });
    },
    forgetPassword() {
      this.isshowLogin = false;
      this.$router.push({
        path: "/forgetPassword",
      });
    },
    goTrial() {
      this.$router.push({
        path: "/index/onTrial",
      });
    },
    selectNav(id, path) {
      window.scrollTo(0, 0);
      this.isNavSelected = id;
      if (path) {
        this.$router.push(path);
      }
    },
    toTop() {
      window.scrollTo(0, 0);
    },
    updateRoute() {
      let path = this.$route.path;
      switch (path) {
        case "/index/digitalTraceability":
          this.isNavSelected = "1";
          break;
        case "/index/fleeingGoods":
          this.isNavSelected = "1";
          break;
        case "/index/digitalMarketing":
          this.isNavSelected = "1";
          break;
        case "/index/codingService":
          this.isNavSelected = "1";
          break;
        case "/index/dataApply":
          this.isNavSelected = "1";
          break;
        case "/index/secondNode":
          this.isNavSelected = "1";
          break;
        case "/index/more":
          this.isNavSelected = "1";
          break;
        case "/index/salt":
          this.isNavSelected = "2";
          break;
        case "/index/huafei":
          this.isNavSelected = "2";
          break;
        case "/index/yurong":
          this.isNavSelected = "2";
          break;
        case "/index/kuaixiaopin":
          this.isNavSelected = "2";
          break;
        case "/index/others":
          this.isNavSelected = "2";
          break;
        case "/index/business":
          this.isNavSelected = "3";
          break;
        case "/index/government":
          this.isNavSelected = "3";
          break;
        case "/index/consumer":
          this.isNavSelected = "3";
          break;
        case "/index/cooperation":
          this.isNavSelected = "4";
          break;
        case "/index/news":
          this.isNavSelected = "5";
          break;
        case "/index/newsDetail":
          this.isNavSelected = "5";
          break;
        case "/index/aboutUs":
          this.isNavSelected = "6";
          break;
        default:
          this.isNavSelected = "0";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  min-width: 1220px;
  // width: 100%;
  height: 140px;
  position: fixed;
  z-index: 999;
  background: #ffffff;
  box-shadow: 0 0 5px 0 #c4c4c4;
}
.nav-box {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  padding-top: 20px;
  .nav-left {
    width: 75%;
    .logo {
      height: 50px;
      img {
        height: 100%;
        width: auto;
      }
    }
    .nav-ul {
      display: flex;
      justify-content: space-between;
      height: 50px;
      margin-top: 20px;
      .nav-li {
        font-size: 17px;
        font-weight: bold;
        line-height: 40px;
        color: #535353;
        position: relative;
        .child-ul {
          display: none;
          position: absolute;
          color: #ffffff;
          font-size: 0.75vw;
          padding: 10px 5px;
          white-space: nowrap;
          z-index: 99;
          margin-left: -15px;
          margin-top: 3px;
          li {
            cursor: pointer;
            text-align: left;
            padding: 5px 25px;
            background: rgba(0, 47, 112, 0.7);
            span {
              font-size: 15px;
            }
          }
        }
      }
      .nav-up-selected {
        border-bottom: 2px solid #3191ee;
      }

      .selected-li {
        color: #3191ee;
        border-bottom: 2px solid #3191ee;
      }
    }
  }
  .title-active {
    cursor: pointer;
  }
  .nav-right {
    width: 25%;
    text-align: right;
    .nav-phone {
      height: 50px;
      img {
        height: 20px;
        width: auto;
        margin-top: 15px;
      }
      div {
        display: inline-block;
        vertical-align: top;
        font-size: 15px;
        color: #3191ee;
        line-height: 20px;
        margin-top: 15px;
        span {
          font-style: italic;
        }
        span:nth-child(2) {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .nav-login {
      height: 50px;
      margin-top: 20px;
      button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
      }
    }
  }

  // .fixed-head {
  //   position: fixed;
  //   top: 0;
  //   z-index: 100;
  //   background-color: #ffffff;
  // }
  // .margin-navbar {
  //   margin-bottom: 37px;
  // }

  // .navbar {
  //   width: 1220px;
  //   height: 100px;
  //   margin-left: auto;
  //   margin-right: auto;

  //   .navbar-logo {
  //     width: 183px;
  //     height: 66px;
  //     position: relative;
  //     top: 50%;
  //     transform: translateY(-50%);
  //     margin-right: 90px;
  //     cursor: pointer;
  //   }

  //   .navbar-input {
  //     width: 270px !important;
  //     display: inline-block;
  //     vertical-align: middle;
  //     margin-right: 5px;
  //   }

  //   .partner-settlement {
  //     background-color: #4866d1 !important;
  //     border-color: #4866d1 !important;
  //     padding: 10px 20px !important;
  //     font-size: 15px !important;
  //   }

  //   .management-center {
  //     border-color: #4866d1 !important;
  //     padding: 10px 20px !important;
  //     font-size: 15px !important;
  //     margin-right: 5px !important;
  //     color: #4866d1 !important;
  //   }

  //   .phone-container {
  //     width: 185px;
  //     vertical-align: middle;
  //     margin-top: -5px;
  //     border-left: 1px solid rgb(237, 237, 237);
  //     padding-left: 9px;
  //   }
  // }


  // .head-v3 {
  //   width: 100%;
  //   .navigation-up {
  //     height: 37px;
  //     box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  //     position: relative;
  //     z-index: 100;
  //     line-height: 37px;
  //     .navigation-inner {
  //       margin: 0 auto;
  //       width: 1220px;

  //       .navigation-v3 {
  //         ul {
  //           display: flex;
  //           justify-content: space-around;
  //           li {
  //             margin-right: 75px;
  //             cursor: pointer;

  //             h2 {
  //               color: #343434;
  //               display: inline-block;
  //               height: 36px;
  //               font-size: 16px;
  //               font-weight: normal;
  //             }
  //           }

  //           .nav-up-selected {
  //             border-bottom: 2px solid #4866d1;
  //           }

  //           .selected-li {
  //             h2 {
  //               color: #4866d1;
  //             }

  //             border-bottom: 2px solid #4866d1;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   .navigation-down {
  //     position: absolute;
  //     // top: 138px;
  //     left: 0px;
  //     width: 100%;

  //     .nav-down-menu {
  //       width: 100%;
  //       margin: 0;
  //       position: absolute;
  //       top: 0px;
  //       background-color: #ffffff;
  //       z-index: 10;
  //       .navigation-down-inner {
  //         margin: auto;
  //         width: 1220px;
  //         position: relative;
  //         height: 360px;

  //         dl {
  //           display: inline-block;
  //           margin: 40px 50px 25px 0;
  //           width: 185px;
  //           vertical-align: top;

  //           dt {
  //             font-size: 16px;
  //             color: #4866d1;
  //             padding-bottom: 20px;
  //             border-bottom: 1px solid #c4c4c4;
  //             margin-bottom: 10px;

  //             img {
  //               width: 20px;
  //               vertical-align: middle;
  //               margin-top: -2px;
  //             }
  //           }

  //           dd {
  //             margin-top: 18px;
  //             color: #787878;
  //             font-size: 14px;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // .to-top {
  // height: 46px;
  // width: 46px;
  // position: fixed;
  // right: 20px;
  // bottom: 40px;
  // cursor: pointer;
  // z-index: 1000;
  // }

  // .mask {
  //   position: fixed;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   top: 0;
  //   background-color: rgba(0, 0, 0, 0.4);
  //   z-index: 122;
  //   .maskwrap {
  //     position: relative;
  //   }
  //   .close {
  //     position: absolute;
  //     right: 36%;
  //     top: 10px;
  //     cursor: pointer;
  //     font-size: 20px;
  //     z-index: 23;
  //     img {
  //       width: 15px;
  //     }
  //   }
  //   .el-tabs {
  //     width: 30%;
  //     margin: 120px auto 0;
  //     background-color: #fff;
  //     /deep/.el-tabs__content {
  //       min-height: 420px;
  //     }
  //     .second {
  //       .btnwrap {
  //         width: 100%;
  //         text-align: center;
  //         margin-top: 180px;
  //       }
  //     }
  //   }
  //   .wrap {
  //     .text {
  //       padding: 24px 48px;
  //       box-sizing: border-box;
  //       .p1 {
  //         font-size: 22px;
  //         color: rgba(35, 103, 174, 1);
  //         margin-bottom: 20px;
  //       }
  //       /deep/.el-form-item {
  //         margin-bottom: 26px;
  //         /deep/.el-input__inner {
  //           height: 60px;
  //         }
  //         .image {
  //           position: absolute;
  //           right: -4px;
  //           top: 0;
  //           width: 100px;
  //           height: 40px;
  //           background: rgba(245, 237, 238, 1);
  //           // border: 4px solid rgba(35, 103, 174, 1);
  //           // border-radius: 8px;
  //         }
  //       }
  //       .btn {
  //         width: 100%;
  //         height: 62px;
  //         font-size: 24px;
  //         color: rgba(245, 237, 238, 1);
  //         background: rgba(35, 103, 174, 1);
  //         border: 4px solid rgba(35, 103, 174, 1);
  //         border-radius: 8px;
  //         text-align: center;
  //         cursor: pointer;
  //       }
  //       .title {
  //         width: 100%;
  //         padding: 10px 0;
  //         font-size: 16px;
  //         color: rgba(35, 103, 174, 1);
  //         .s2 {
  //           float: right;
  //           cursor: pointer;
  //         }
  //       }
  //     }
  //   }
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue